import React from "react";

/**
 * @component EyeOffSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <EyeOffSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const EyeOffSmallIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="EyeOffSmallIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M1.05 1.05l9.9 9.9-.707.707L8.205 9.62C7.517 9.866 6.775 10 6 10 3.273 10 .944 8.341 0 6a6.35 6.35 0 011.971-2.615L.343 1.757l.707-.707zM1.19 6C2.09 7.792 3.95 8.933 6 8.933c.463 0 .915-.058 1.35-.168L6.176 7.59c-.058.006-.117.009-.176.009-.904 0-1.636-.716-1.636-1.6 0-.07.004-.14.013-.207L2.736 4.15A5.273 5.273 0 001.189 6zM6 2c2.727 0 5.056 1.659 6 4a6.35 6.35 0 01-1.972 2.615l-.765-.766A5.273 5.273 0 0010.811 6C9.91 4.208 8.05 3.067 6 3.067c-.463 0-.916.058-1.35.168l-.857-.855A6.553 6.553 0 016 2zm0 2.4c.904 0 1.636.716 1.636 1.6 0 .07-.004.14-.013.208l-1.8-1.799C5.88 4.403 5.94 4.4 6 4.4z"
        fillRule="evenodd"
      />
    </svg>
  )
);
EyeOffSmallIcon.displayName = "EyeOffSmallIcon";
export default EyeOffSmallIcon;
